module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0d251e7bd27c0ef2e6abbdd2c32c4b6b.png";